import React from 'react';
import { MapCanvas } from './MapCanvas';
export interface MapVisualAidProps {
  data: {
    mapId: string;
    highlightRegionIds?: string[];
    highlightStyle?: 'primary' | 'secondary' | 'subtle';
    label?: string;
  };
}
export function MapVisualAid({
  data
}: MapVisualAidProps) {
  return <div className="flex flex-col items-center gap-3 w-full" data-id="element-13092">
      <MapCanvas mapId={data.mapId} highlightRegionIds={data.highlightRegionIds} highlightStyle={data.highlightStyle} width={400} height={400} ariaLabel={data.label} data-id="element-13093" />
      {data.label && <p className="text-sm font-medium text-stone-600 text-center" data-id="element-13094">
          {data.label}
        </p>}
    </div>;
}